/* eslint-disable react/prop-types */
import { Box, Link, Typography } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

const isImageUrl = (url) =>
  Boolean(url) &&
  (/\.(png|jpe?g|gif|webp|bmp)(\?|$)/i.test(url) ||
    /\/images\//i.test(url) ||
    /agent-uploads/i.test(url));

export default function ChatAttachment({ url, name }) {
  if (!url) return null;

  if (isImageUrl(url)) {
    return (
      <Box
        component="a"
        href={url}
        target="_blank"
        rel="noreferrer"
        sx={{
          display: 'block',
          mt: 1,
          borderRadius: 1.5,
          overflow: 'hidden',
          border: '1px solid rgba(255,255,255,0.25)',
          maxWidth: 200,
        }}
      >
        <Box
          component="img"
          src={url}
          alt={name || 'Attachment'}
          sx={{ width: '100%', maxHeight: 120, objectFit: 'cover', display: 'block' }}
        />
      </Box>
    );
  }

  return (
    <Link
      href={url}
      target="_blank"
      rel="noreferrer"
      underline="hover"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        mt: 1,
        color: 'rgba(255,255,255,0.95)',
        fontSize: 13,
      }}
    >
      <DescriptionOutlinedIcon sx={{ fontSize: 16 }} />
      <Typography variant="caption" sx={{ color: 'inherit', wordBreak: 'break-all' }}>
        {name || 'Download file'}
      </Typography>
    </Link>
  );
}
